import PropTypes from 'prop-types'

/*
EXAMPLE:
{
  isExact: true,
  params: {
    id: 'ABC',
    section: 'soccer',
  },
  path: '/',
  url: 'http://',
}
*/

export default PropTypes.shape({
  isExact: PropTypes.bool,
  params: PropTypes.shape({
    id: PropTypes.string,
    section: PropTypes.string,
  }),
  path: PropTypes.string,
  url: PropTypes.string,
})
